import React, {Component} from "react";

export default class FlexDivider extends Component{



    render() {
        return (
            <div style={{display:"flex",flexGrow:1}}/>
        )
    }
}